module.exports = __webpack_public_path__ + "media/t_legis.58a4676e.webm";